export default "__VITE_ASSET__BSXvDjnV__"